(function () {
    function init() {
        var container = document.getElementById("cn-box-products");

        if (!container) {
            return;
        }

        // An element containing all of the product thumbnails (images of what you get in your box)
        var thumbnails = container.querySelector(".related-product-thumbnails");

        // The elements containing detailed information about the products you get in your box (e.g. if you click on a thumbnail the cooresponding display will show up)
        var displays = container.querySelectorAll(".related-product-display");

        // All of the links that can be clicked to show a product or close the current product being displayed
        var links = container.querySelectorAll(".related-products a");

        /** Hides all of the product displays */
        function hideDisplays() {
            for (var i = 0; i < displays.length; i += 1) {
                displays[i].classList.add("d-none");
            }
        }

        /** Shows the product thumbnails and hides all the product displays */
        function showThumbnails() {
            hideDisplays();

            if (thumbnails) {
                thumbnails.classList.remove("d-none");
            }
        }

        /** Shows a product's display based on it's ID */
        function showProduct(productId) {
            if (!productId) {
                return;
            }

            hideDisplays();

            if (thumbnails) {
                thumbnails.classList.add("d-none");
            }

            var target = container.querySelector(
                ".related-product-display[data-product-id='" + productId + "']"
            );

            if (target) {
                target.classList.remove("d-none");
            }
        }

        for (var i = 0; i < links.length; i += 1) {
            const anchor = links[i];

            anchor.addEventListener("click", function (event) {
                // If someone clicks the close button, close the current product being displayed.
                if (anchor.classList.contains("close-button")) {
                    event.preventDefault();
                    showThumbnails();
                    return;
                }

                // Get the product ID that was clicked
                var productId = anchor.getAttribute("data-product-id");

                if (productId) {
                    showProduct(productId);
                }
            });
        }
    }

    // Since this script can be loaded with the `async` attribute, we need to check if the DOM is already ready before initializing.
    // e.g. if you use a DOMContentLoaded listener, it may never fire since the page is already ready.
    if (document.readyState === "loading") {
        var onReady = function () {
            document.removeEventListener("DOMContentLoaded", onReady);
            init();
        };

        document.addEventListener("DOMContentLoaded", onReady);
    } else {
        init();
    }
})();